import { AxiosRequestConfig } from 'axios';
import { resetPassword } from '@store/modules/reset-password';

export function passwordResetSessionUuidHeader(config: AxiosRequestConfig): AxiosRequestConfig {
	if (resetPassword.passwordResetSessionUuid === '') {
		throw new Error('UUID must be present in store to add to header');
	}
	const passwordResetSessionUuid = {
		'password-reset-session-uuid': resetPassword.passwordResetSessionUuid
	};
	config.headers = { ...config.headers, ...passwordResetSessionUuid };
	return config;
}
